import { isDefined } from './types.utils';

export function capitalize(value: string): string;
export function capitalize(value: null | undefined): null;
export function capitalize(value: string | null | undefined): string | null;
export function capitalize(value: string | null | undefined): string | null {
  if (!isDefined(value)) {
    return null;
  }

  return `${value.substring(0, 1).toUpperCase()}${value.substring(1)}`;
}

export function transliterate(word: string): string;
export function transliterate(word: null | undefined): null;
export function transliterate(word: string | null | undefined): string | null;
export function transliterate(word: string | null | undefined): string | null {
  if (!isDefined(word)) {
    return null;
  }

  if (!word) {
    return '';
  }

  let answer = '';
  const dict: Record<string, string> = {
    Ё: 'YO',
    Й: 'I',
    Ц: 'TS',
    У: 'U',
    К: 'K',
    Е: 'E',
    Н: 'N',
    Г: 'G',
    Ш: 'SH',
    Щ: 'SCH',
    З: 'Z',
    Х: 'H',
    Ъ: "'",
    ё: 'yo',
    й: 'i',
    ц: 'ts',
    у: 'u',
    к: 'k',
    е: 'e',
    н: 'n',
    г: 'g',
    ш: 'sh',
    щ: 'sch',
    з: 'z',
    х: 'h',
    ъ: "'",
    Ф: 'F',
    Ы: 'I',
    В: 'V',
    А: 'A',
    П: 'P',
    Р: 'R',
    О: 'O',
    Л: 'L',
    Д: 'D',
    Ж: 'ZH',
    Э: 'E',
    ф: 'f',
    ы: 'i',
    в: 'v',
    а: 'a',
    п: 'p',
    р: 'r',
    о: 'o',
    л: 'l',
    д: 'd',
    ж: 'zh',
    э: 'e',
    Я: 'Ya',
    Ч: 'CH',
    С: 'S',
    М: 'M',
    И: 'I',
    Т: 'T',
    Ь: "'",
    Б: 'B',
    Ю: 'YU',
    я: 'ya',
    ч: 'ch',
    с: 's',
    м: 'm',
    и: 'i',
    т: 't',
    ь: "'",
    б: 'b',
    ю: 'yu',
    ' ': '_',
  };

  for (const char of word) {
    if (char in dict && isDefined(dict[char])) {
      answer += dict[char];
    } else {
      answer += char;
    }
  }

  return answer.toLowerCase();
}
